/**
 * All valid values for the `messageType` of System Message Components.
 */
export type MessageType = 'info' | 'success' | 'warning' | 'error';

/**
 * Default value for `messageType` of System Message Components.
 */
export const DEFAULT_SYSTEM_MESSAGE_TYPE: MessageType = 'info';
